import { updateSelectedViewType } from '../actions/publicActions';
import { updateCalendarPreferredViewType } from '../utils/updateCalendarPreferredViewType';
import { orchestrator } from 'satcheljs';
import {
    onAvailableWidthBucketChanged,
    getBrowserWidthBucket,
    LayoutChangeSource,
} from 'owa-layout';

orchestrator(updateSelectedViewType, actionMessage => {
    // update the preferred view type in user configuration at server side
    updateCalendarPreferredViewType(actionMessage.viewType);

    // trigger layout update
    onAvailableWidthBucketChanged(
        getBrowserWidthBucket(),
        LayoutChangeSource.CalendarViewTypeChange
    );
});
